"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var WCClassificationResource = /** @class */ (function (_super) {
    tslib_1.__extends(WCClassificationResource, _super);
    function WCClassificationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WCClassificationResource.endpoint = '/wcclassifications';
    WCClassificationResource.MODEL_NAME = 'wcclassification';
    return WCClassificationResource;
}(base_1.default));
exports.default = WCClassificationResource;
//# sourceMappingURL=wcclassification.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/wcclassification.js
// module id = ouhY
// module chunks = 0